import React from "react";
import { SvgCommon } from ".";
import { IconModel } from "../../models";

export const EditIcon: React.FC<IconModel> = (props) => {
  return (
    <SvgCommon {...props}>
      <path d="M9.16663 3.33325H3.33329C2.89127 3.33325 2.46734 3.50885 2.15478 3.82141C1.84222 4.13397 1.66663 4.55789 1.66663 4.99992V16.6666C1.66663 17.1086 1.84222 17.5325 2.15478 17.8451C2.46734 18.1577 2.89127 18.3333 3.33329 18.3333H15C15.442 18.3333 15.8659 18.1577 16.1785 17.8451C16.491 17.5325 16.6666 17.1086 16.6666 16.6666V10.8333" stroke={props.color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15.3415 2.18007C15.6702 1.85139 16.116 1.66675 16.5808 1.66675C17.0456 1.66675 17.4914 1.85139 17.8201 2.18007C18.1487 2.50874 18.3334 2.95451 18.3334 3.41933C18.3334 3.88414 18.1487 4.32992 17.8201 4.65859L11.6381 10.8406L8.33337 11.6667L9.15955 8.36205L15.3415 2.18007Z" stroke={props.color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </SvgCommon>
  );
};